import React, { useEffect } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import useTitle from '../../hooks/title'
import { queryTransactions } from './AccountAPI'
import { showOrders } from './AccountAPI'
import classes from './Billing.module.scss'
import dayjs from 'dayjs'
import { runInAction } from 'mobx'


const Row = observer(({data}) => {
  return <div className={classes.row}>
    <div className={classes.rowLeft}>
      ${data?.amount_with_breakdown?.gross_amount?.value || ''} paid using PayPal
    </div>
    <div className={classes.rowRight}>
      {dayjs(data.time).format('MMMM D YYYY')}
    </div>
</div>
});

const OrderRow = observer(({data}) => {
  if (data.orderId !== undefined)
    return <div className={classes.row}>
        <div className={classes.rowLeft}>
          {data.appId} redeemed using code {data.orderId}
        </div>
        <div className={classes.rowRight}>
          {dayjs(data.createTime).format('MMMM D YYYY')}
        </div>
    </div>
  else
    return <div className={classes.row}>
        <div className={classes.rowLeft}>
          ${data?.purchase_units[0]?.amount?.value || ''} paid using {data.payment_source?.card !== undefined ? 
          data.payment_source?.card.brand + " ending in " + data.payment_source?.card.last_digits 
          : "PayPal"}
        </div>
        <div className={classes.rowRight}>
          {dayjs(data.update_time).format('MMMM D YYYY')}
        </div>
    </div>  
});

const Billing = observer(() => {
  useTitle('Account Billing')
  const model = useLocalObservable(() => ({
    loading: true,
    list: [],
    orders: [],
    async load() {
      try {
        this.loading = true
        const rs = await queryTransactions()
        this.setList(rs.transactions || [])
      } catch(e) {
        //
        this.setList([])
      } finally {
        runInAction(() => this.loading = false)
      }
    },
    async orderLoad() {
      try {
        this.loading = true
        const rs = await showOrders()
        this.setOrders(rs || [])
      } catch(e) {
        //
        this.setOrders([])
      } finally {
        runInAction(() => this.loading = false)
      }
    },
    setList(list) {
      this.list = list;
    },
    setOrders(orders) {
      this.orders = orders;
    }
  }))
  useEffect(() => {
    model.orderLoad()
    model.load()
  }, [])

  if (model.loading) {
    return <div  className={classes.root}>
    </div>
  }

  if (model.list.length == 0 && model.orders.length == 0) {
    return <div  className={classes.root}>
      <div className={classes.empty}>You don’t have any transactions yet.</div>
    </div>
  }

  return <div  className={classes.root}>
    <h2>Transaction History</h2>
    {model.orders.map(row => <OrderRow key={row.id} data={row} />)}
    {model.list.map(row => <Row key={row.id} data={row} />)}
  </div>
})

export default Billing;